import DOMPurify from "dompurify";

export const RichTextDisplay = ({ richText }: { richText: string }) => {
  const sanitizedRichText = DOMPurify.sanitize(richText);

  return (
    <div
      className="tiptap"
      dangerouslySetInnerHTML={{ __html: sanitizedRichText }}
    ></div>
  );
};
